<template>
  <div>
    <!-- This modal is for choosing the export filetype -->
    <div
      class="modal fade"
      id="exportTranslation"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <!-- Close button in the upper right corner -->
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>

            <!-- Modal title -->
            <h4 class="modal-title">
              <b>{{ lang.U1051 }}</b>
            </h4>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <p>
                <b>{{ lang.U1052 }}</b>
              </p>

              <!-- <div class="col-md-8 col-md-offset-2" style="padding-bottom: 20px;">
                <select
                  id="selectExportFiletype"
                  class="form-control"
                  v-model="exportTranslationFileType"
                >
                  <option value="csv">{{lang.U1053}}</option>
                  <option value="xls">{{lang.U1054}}</option>
                  <option value="xlsx">{{lang.U1055}}</option>
                  <option value="json">JSON (*.json)</option>
                </select>
              </div>-->
            </div>
          </div>
          <div class="modal-footer">
            <!-- Add modal buttons here -->
            <button
              type="button"
              class="btn btn-raised btn-default"
              data-dismiss="modal"
            >
              {{ lang.U1049 }}
            </button>
            <button
              type="button"
              class="btn btn-raised dialog-btn-primary"
              @click="downloadTranslationExportData()"
            >
              {{ lang.U1056 }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- This modal is for the input of the translation import data -->
    <div
      class="modal fade"
      id="importTranslation"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <!-- Close button in the upper right corner -->
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>

            <!-- Modal title -->
            <h4 class="modal-title">
              <b>{{ lang.U1041 }}</b>
            </h4>
          </div>
          <div class="modal-body">
            <form class="form-horizontal">
              <div class="form-group">
                <p>
                  <b>{{ lang.U1042 }}</b>
                </p>

                <!-- Tabs for selecting the import type -->
                <ul class="nav nav-tabs nav-import" style="margin-bottom: 15px">
                  <li class="active">
                    <a
                      href="#textImport"
                      data-toggle="tab"
                      @click="
                        importTranslationDialogData.selectedOption = 'text'
                      "
                      >{{ lang.U1043 }}</a
                    >
                  </li>
                  <li>
                    <a
                      href="#fileImport"
                      data-toggle="tab"
                      @click="
                        importTranslationDialogData.selectedOption = 'file'
                      "
                      >{{ lang.U1044 }}</a
                    >
                  </li>
                </ul>
                <div id="importTabContent" class="tab-content">
                  <div class="tab-pane fade active in" id="textImport">
                    <!-- Textarea for text-import -->
                    <label
                      for="textAreaImport"
                      class="col-md-1 control-label"
                      >{{ lang.U1045 }}</label
                    >
                    <div class="col-md-11">
                      <textarea
                        class="form-control"
                        rows="7"
                        id="textAreaImport"
                        v-model="importTranslationDialogData.selectedText"
                      ></textarea>
                      <span class="help-block">{{ lang.U1046 }}</span>
                    </div>
                  </div>

                  <div class="tab-pane fade" id="fileImport">
                    <!-- File upload for file-import -->
                    <label
                      for="inputFileImport"
                      class="col-md-1 control-label"
                      >{{ lang.U1047 }}</label
                    >
                    <div class="col-md-11">
                      <input
                        class="form-control"
                        type="file"
                        multiple
                        accept=".csv, .xls, .xlsx"
                        @change="onImportFileChange"
                      />
                      <div class="input-group">
                        <label
                          v-if="
                            typeof importTranslationDialogData.selectedFile
                              .name == 'undefined'
                          "
                          style="padding-top: 16px"
                          >{{ lang.U1048 }}</label
                        >
                        <label v-else style="padding-top: 16px">{{
                          importTranslationDialogData.selectedFile.name
                        }}</label>
                        <span class="input-group-btn input-group-sm">
                          <button
                            type="button"
                            class="btn btn-fab btn-fab-mini"
                          >
                            <i class="material-icons">attach_file</i>
                          </button>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <!-- Add modal buttons here -->
            <button
              type="button"
              class="btn btn-raised btn-default"
              data-dismiss="modal"
            >
              {{ lang.U1049 }}
            </button>
            <button
              type="button"
              class="btn btn-raised dialog-btn-primary"
              @click="uploadImportData()"
            >
              {{ lang.U1050 }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- ******************* -->
    <!-- *      Modal      * -->
    <!-- ******************* -->
    <!-- This modal is for editing survey translation -->
    <div
      class="modal fade"
      id="translateSurveyDialog"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <form id="surveyTranslateForm">
            <div class="modal-header">
              <!-- Close button in the upper right corner -->
              <button
                type="button"
                class="close"
                aria-hidden="true"
                @click="closeTranslateSurveyDialog()"
              >
                ×
              </button>

              <!-- Modal Title -->
              <h4 class="modal-title">
                <b>{{ dialogTitle }}</b>
              </h4>
            </div>
            <div class="modal-body">
              <div class="row" id="surveyTranslationTopRow">
                <div class="form-group">
                  <label
                    for="inputSurveyLanguage"
                    class="translate-label control-label"
                    >{{ lang.U1018 }}</label
                  >
                  <select2
                    class="form-control"
                    id="inputSurveyLanguage"
                    :width="'200px'"
                    @change="selectedLanguageChanged"
                    :placeholder="lang.U1072"
                  >
                    <option
                      v-for="value in surveyLocales"
                      :key="value.LocaleCode"
                      :value="value.LocaleCode"
                    >
                      {{ value.LocaleName }}
                    </option>
                  </select2>
                  <button
                    type="button"
                    class="btn btn-raised btn-default"
                    :disabled="
                      translationList.length < 1 ||
                      !globals.isAccessAllowed(
                        'LoopOp_SurveyTranslationExport_Create'
                      )
                    "
                    data-toggle="modal"
                    data-target="#exportTranslation"
                  >
                    {{ lang.U0056 }}
                  </button>
                  <!-- <button
                    type="button"
                    class="btn btn-raised btn-default"
                    :disabled="true || Object.keys(translationList).length < 1"
                    data-toggle="modal"
                    data-target="#importTranslation"
                  >{{lang.U0057}}</button>-->
                  <button
                    type="button"
                    class="btn btn-raised"
                    v-if="globals.currentUserRole == 1"
                    :class="{
                      'btn-success': !translationData.AllowAgencyEdit,
                      'btn-warning': translationData.AllowAgencyEdit,
                    }"
                    @click="toggleAgencyTranslatePermission()"
                    :disabled="!selectedLanguage"
                  >
                    {{
                      translationData.AllowAgencyEdit ? lang.U1071 : lang.U1070
                    }}
                  </button>
                  <button
                    type="button"
                    class="btn btn-raised btn-success"
                    v-if="globals.currentUserRole == 2"
                    @click="submitTranslationsFromAgency()"
                    :disabled="
                      !selectedLanguage || !translationData.AllowAgencyEdit
                    "
                  >
                    {{ lang.U1073 }}
                  </button>
                </div>
              </div>
              <div class="row">
                <div id="surveyTranslation" class="modalScrollableArea">
                  <div v-for="(item, key) in translationList" :key="key">
                    <hr
                      v-if="isNewGroup(item.ParentId) && !item.QuestionName"
                    />
                    <div class="form-group col-md-12">
                      <label
                        :for="'textareaTranslationElement' + key"
                        class="col-md-6 translate-label"
                        :class="{
                          'translate-label-child':
                            item.Key !== 'title' && item.ParentId > 0,
                        }"
                      >
                        <span v-if="item.Key === 'title' && item.QuestionNumber"
                          >{{ item.QuestionNumber }} -</span
                        >
                        {{ item.Name }}
                      </label>
                      <div class="col-md-6">
                        <textarea
                          :id="'textareaTranslationElement' + key"
                          class="form-control textarea-survey-translations autoExpand"
                          v-model="item.Translation"
                          @change="translationListDirty = true"
                          maxlength="1000"
                          rows="1"
                          :disabled="
                            globals.currentUserRole == 2 &&
                            !translationData.AllowAgencyEdit
                          "
                          :placeholder="item.InheritedTranslation"
                        />
                      </div>
                    </div>
                    {{ setNewGroup(item.ParentId) }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row modal-footer">
              <div class="col-md-12">
                <button
                  type="button"
                  class="btn btn-raised btn-default"
                  @click="closeTranslateSurveyDialog()"
                >
                  {{ lang.U1057 }}
                </button>
                <button
                  type="button"
                  class="btn btn-raised"
                  :class="{
                    'btn-warning': translationListDirty,
                    'btn-success': !translationListDirty,
                  }"
                  :disabled="
                    translationList.length < 1 ||
                    !globals.isAccessAllowed(
                      'LoopOp_SurveyTranslation_Update'
                    ) ||
                    (globals.currentUserRole == 2 &&
                      !translationData.AllowAgencyEdit)
                  "
                  @click="saveTranslateSurveyDialogData()"
                >
                  {{ lang.U0023 }}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Select2 from "../Tools/Select2";

export default {
  name: "SurveyManagementTranslateModal",
  components: {
    Select2,
  },
  mounted() {
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    $("#translateSurveyDialog").on("hidden.bs.modal", (e) => {
      this.$emit("dialogClosed");
    });
  },
  methods: {
    // Adjusts the height of textareas with the "autoExpand" class
    correctTextareaHeight() {
      this.$nextTick(() => {
        let textareas = document.getElementsByClassName("autoExpand");
        for (let i = 0; i < textareas.length; i++) {
          $(textareas[i]).trigger("input");
        }
      });
    },
    openTranslateSurveyDialog() {
      this.dialogTitle = this.lang.U1039;
      this.selectedLanguage = "";
      this.translationList = [];
      this.translationListDirty = false;
      this.loadSurveyLocales();
      $("#translateSurveyDialog").modal("show");
    },
    closeTranslateSurveyDialog() {
      if (this.translationListDirty) {
        this.globals.$emit("openGlobalUnsavedChangesDialog", () => {
          $("#translateSurveyDialog").modal("hide");
        });
        return;
      }
      $("#translateSurveyDialog").modal("hide");
    },
    loadSurveyLocales() {
      let queryString = `api/SurveyTranslation/${this.selectedSurvey.SurveyId}/Locales`;

      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          this.surveyLocales = data;
          this.$nextTick(() => {
            $("#inputSurveyLanguage").val("").trigger("change");
          });
        },
        error: () => {
          console.error(
            "Survey locale data access failed in loadSurveyLocales()"
          );
          this.globals.showErrorSnackbar("Survey locale data access failed");
        },
      });
    },
    selectedLanguageChanged(value, event) {
      if (!value) return;
      if (this.translationListDirty) {
        this.globals.$emit(
          "openGlobalUnsavedChangesDialog",
          () => {
            this.selectedLanguage = value;
            this.loadSurveyTranslation();
          },
          () => {
            $(event.target).val(this.selectedLanguage).trigger("change");
          }
        );
        return;
      }
      this.selectedLanguage = value;
      this.loadSurveyTranslation();
    },
    loadSurveyTranslation() {
      let queryString = `api/SurveyTranslation/${this.selectedSurvey.SurveyId}?localeCode=${this.selectedLanguage}`;

      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          this.translationData = data;
          this.translationList = this.translationData.Translations;
          this.translationListDirty = false;
          this.correctTextareaHeight();
        },
        error: () => {
          console.error(
            "Survey translation data access failed in loadSurveyTranslation()"
          );
          this.globals.showErrorSnackbar("Translation data access failed");
        },
      });
    },
    toggleAgencyTranslatePermission() {
      this.translationData.AllowAgencyEdit = !this.translationData
        .AllowAgencyEdit;
      this.updateAgencyTranslatePermission();
    },
    submitTranslationsFromAgency() {
      this.translationData.AllowAgencyEdit = false;
      if (this.translationListDirty)
        this.saveTranslateSurveyDialogData(() => {
          this.updateAgencyTranslatePermission();
        });
      else this.updateAgencyTranslatePermission();
    },
    updateAgencyTranslatePermission() {
      let sendData = { AllowAgencyEdit: this.translationData.AllowAgencyEdit };
      let queryString = `api/SurveyTranslation/${this.selectedSurvey.SurveyId}?localeCode=${this.selectedLanguage}`;

      $.ajax({
        method: "PATCH",
        url: queryString,
        data: JSON.stringify(sendData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          if (this.globals.currentUserRole == 1)
            this.globals.showSuccessSnackbar("Permission update successful");
          else if (this.globals.currentUserRole == 2)
            this.globals.showSuccessSnackbar("Translations submitted");
        },
        error: () => {
          console.error("Error on PATCH in toggleAgencyTranslatePermission()");
          if (this.globals.currentUserRole == 1)
            this.globals.showSuccessSnackbar("Permission update failed");
          else if (this.globals.currentUserRole == 2)
            this.globals.showSuccessSnackbar("Translations submit failed");
        },
      });
    },
    isNewGroup(currGroupId) {
      return currGroupId !== this.groupId;
    },
    setNewGroup(currGroupId) {
      this.groupId = currGroupId;
    },
    saveTranslateSurveyDialogData(callback) {
      let queryString = `api/SurveyTranslation/${this.selectedSurvey.SurveyId}?localeCode=${this.selectedLanguage}`;

      $.ajax({
        method: "PUT",
        url: queryString,
        data: JSON.stringify(this.translationData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          if (data.Error) {
            console.error(data.Error);
            this.globals.showErrorSnackbar(data.Error);
            this.loadSurveyTranslation();
            return;
          }
          this.translationListDirty = false;
          this.globals.showSuccessSnackbar(
            "Translation data update successful"
          );
          if (callback) callback();
        },
        error: () => {
          console.error("Error on POST in saveTranslateSurveyDialogData()");
          this.globals.showErrorSnackbar("Translation data update failed");
        },
      });
    },
    downloadTranslationExportData() {
      let queryString = `api/SurveyTranslation/Export?file_type=${this.exportTranslationFileType}`;

      $.ajax({
        method: "POST",
        url: queryString,
        data: JSON.stringify(this.translationList),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          var guid = data[0].DownloadId;
          $(window).prop("location", "api/Download/" + guid);
          $("#exportTranslation").modal("hide");
        },
        error: () => {
          console.error("Error on POST in downloadExportTranslationData()");
          this.globals.showErrorSnackbar("Translation export failed");
        },
      });
    },
    // Uploads import data to the server and manipulates the UI depending on the progress and response from the server
    uploadImportData() {
      if (this.importTranslationDialogData.selectedOption == "text") {
        if (this.importTranslationDialogData.selectedText == "") {
          console.error(
            "Error: No import text available in uploadImportData()"
          );
          return;
        }

        this.translationList = JSON.parse(
          this.importTranslationDialogData.selectedText
        );
      } else if (this.importTranslationDialogData.selectedOption == "file") {
        if (
          typeof this.importTranslationDialogData.selectedFile == "undefined"
        ) {
          console.error(
            "Error: No import file available in uploadImportData()"
          );
          return;
        }
        console.log(
          "Uploading file: " +
            this.importTranslationDialogData.selectedFile.name
        );

        var reader = new FileReader();
        reader.readAsDataURL(this.importTranslationDialogData.selectedFile);
        reader.onload = () => {};
        reader.onerror = (error) => {};
      } else console.error("Error on file upload in uploadImportData()");
      $("#importTranslation").modal("hide");
    },

    // Writes the filename to the input of the file import, after a file was selected
    onImportFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;

      var uploadFile = files[0];
      if (typeof uploadFile.name == "undefined" || uploadFile.name == "")
        return;
      this.importTranslationDialogData.selectedFile = uploadFile;
    },

    // Cleans up the import data after the import got closed
    importClosed() {
      this.displayTranslationImport = false;
      this.importTranslationDialogData.selectedText = "";
      this.importTranslationDialogData.selectedFile = {};
    },
  },
  watch: {
    showDialog() {
      if (this.showDialog) this.openTranslateSurveyDialog();
    },
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
    },
  },
  props: ["selectedSurvey", "showDialog"],
  data() {
    // Global data inside the component is stored here
    return {
      dialogTitle: "",
      translationList: [],
      translationData: {},
      translationListDirty: false,
      surveyLocales: {},
      selectedLanguage: "",
      exportTranslationFileType: "xlsx",
      importTranslationDialogData: {
        selectedOption: "text", // Should be "text" or "file"
        selectedText: "", // String that is pasted to the textarea on text import
        selectedFile: {}, // File informations of the selected file on file import
        serverResponse: {}, // Response data from the server has to be stored here
        trimImportData: false,
      },
      lang: {
        U0023: "Save",
        U1039: "Survey Translation",
        U1018: "Language selection",
        U0056: "Export",
        U0057: "Import",
        U1041: "Survey Import",
        U1042: "Please select an import option",
        U1043: "Text-Import",
        U1044: "File-Import",
        U1045: "Text",
        U1046: "Please insert the table data to be imported here.",
        U1047: "File",
        U1048: "Please select a file...",
        U1049: "Cancel",
        U1050: "OK",
        U1051: "Export translations",
        U1052: "The translation data is ready to download.",
        U1053: "Text CSV (.csv)",
        U1054: "Microsoft Excel 97-2003 (.xls)",
        U1055: "Microsoft Excel 2007-2013 XML (.xlsx)",
        U1056: "Download",
        U1057: "Close",
        U1058: "Load translations",
        U1070: "Enable for agency",
        U1071: "Disable for agency",
        U1072: "Please select...",
        U1073: "Submit",
      },
    };
  },
};
</script>

<style>
#translateSurveyDialog #inputSurveyLanguage + .select2.select2-container {
  margin: -1px 20px 0 10px;
  height: fit-content;
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.modalScrollableArea {
  max-height: calc(100vh - 250px);
  overflow-y: auto;
}

.modal-lg {
  width: 90vw;
}

#surveyTranslation .form-group {
  margin-bottom: 10px;
}
#surveyTranslation hr {
  clear: both;
  margin: 10px 0 10px 0;
  background-color: lightgray;
  height: 3px;
}

.translate-label {
  font-size: 16px !important;
  margin: 10px 0 0 0;
  color: gray;
  text-align: left;
}
.translate-label-child {
  padding-left: 55px;
}

.textarea-survey-translations {
  display: block;
  overflow: hidden;
  margin: 0;
  padding: 7px 0;
}

#surveyTranslationTopRow > .form-group {
  display: inline-flex;
}
#surveyTranslationTopRow label {
  margin-top: 10px;
}
#surveyTranslationTopRow select {
  margin: 0 20px 0 20px;
}
#surveyTranslationTopRow button {
  margin: 0 10px 15px 0;
  height: 36px;
}
</style>



// WEBPACK FOOTER //
// SurveyManagementTranslateModal.vue?74b5fe6b